"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Hidden = _interopRequireDefault(require("../Hidden/Hidden"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var enableFullScreen = function enableFullScreen(WrappedComponent) {
  var SelectFiled = function SelectFiled(_ref) {
    var fullScreen = _ref.fullScreen,
        props = _objectWithoutProperties(_ref, ["fullScreen"]);

    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Hidden.default, {
      lgUp: true
    }, _react.default.createElement(WrappedComponent, Object.assign({
      fullScreen: fullScreen
    }, props))), _react.default.createElement(_Hidden.default, {
      mdDown: true
    }, _react.default.createElement(WrappedComponent, props)));
  };

  SelectFiled.defaultProps = {
    fullScreen: false
  };
  return SelectFiled;
};

var _default = enableFullScreen;
exports.default = _default;